export default function getResource(label) {
    const resources = {
        cancelButton: 'Cancel',
        modalTitle: 'Change Date',
        nextShipment: 'Next Shipment:',
        submitButton: 'Choose This Date',
        submitButtonSuccess: 'Date Changed!'
    };

    return resources[label];
}
